export default __webpack_public_path__ + "media/images/backgrounds/mud_splats/splat-2-0c8900aea49d9ff450b0911788987ec4.svg";